import { ThemeableComponent } from '../utils/theme/ThemeableComponent';
import {
    createPopper,
    Instance,
    Modifier,
    OptionsGeneric,
    VirtualElement,
} from '@popperjs/core';

export abstract class Popper<
    T = {},
    TState = {},
    TThemeKeys = {}
> extends ThemeableComponent<T, TState, TThemeKeys> {
    protected popperOptions:
        | Partial<OptionsGeneric<Partial<Modifier<any, any>>>>
        | undefined;
    protected popper: Instance | undefined;

    protected anchorNode: Element | VirtualElement | undefined;

    protected popupNode: HTMLElement | undefined;

    protected arrowNode: HTMLElement | undefined;
    private defaultPopperOptions: Partial<
        OptionsGeneric<Partial<Modifier<any, any>>>
    > = {
        placement: 'top',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, 5],
                },
            },
        ],
    };

    constructor(props: T) {
        super(props);
    }

    componentDidMount() {
        this.initializePopup();
    }

    componentDidUpdate(prev: T) {
        this.initializePopup();
    }

    componentWillUnmount() {
        if (this.popper) {
            this.popper.destroy();
        }
    }

    protected abstract get popperEnabled(): boolean;

    protected setAnchorNodeRef = (nodeRef: Element | VirtualElement) => {
        this.anchorNode = nodeRef;
    };
    protected setPopupNodeRef = (nodeRef: HTMLElement) => {
        this.popupNode = nodeRef;
    };
    protected setArrowNodeRef = (nodeRef: HTMLElement) => {
        this.arrowNode = nodeRef;
    };

    protected initializePopup = () => {
        if (this.popperEnabled && this.anchorNode && this.popupNode) {
            const popperOptions = this.getPopperOptions();
            if (popperOptions) {
                this.popper = createPopper(
                    this.anchorNode,
                    this.popupNode,
                    popperOptions
                );
            }
        }
    };

    protected getPopperOptions(): Partial<
        OptionsGeneric<Partial<Modifier<any, any>>>
    > {
        const options = this.popperOptions || this.defaultPopperOptions;
        if (!!this.arrowNode) {
            if (!options.modifiers) {
                options.modifiers = [];
            }
            if (
                !options.modifiers.find(modifier => modifier.name === 'arrow')
            ) {
                options.modifiers.push({
                    name: 'arrow',
                    options: {
                        element: this.arrowNode,
                    },
                });
            }
        }
        return options;
    }

    protected updatePopper() {
        if (this.popper) {
            this.popper.update();
        }
    }
}



// WEBPACK FOOTER //
// ./src/utils/Popper.ts